export const POS_SHOW_PRODUCT_IMAGES_KEY = "pos_show_product_images";
export const POS_SHOW_PRODUCT_PRICES_KEY = "pos_show_product_prices";
export const POS_SHOW_PRODUCT_QUANTITY_BUTTONS_KEY = "pos_show_product_quantity_buttons";
export const POS_SHOW_PRODUCT_QUANTITY_FIELD_KEY = "pos_show_product_quantity_field";
export const POS_DISPLAY_PREFERENCES_EVENT = "pos-display-preferences-changed";

export const readPOSDisplayPreference = (key) => {
  const saved = localStorage.getItem(key);
  return saved === null ? true : saved === "true";
};

export const writePOSDisplayPreference = (key, value) => {
  localStorage.setItem(key, value ? "true" : "false");
  window.dispatchEvent(new Event(POS_DISPLAY_PREFERENCES_EVENT));
};
